<template>
  <div id="app-root" :class="{ 'app-root--portal': isPortalSite }">
    <router-view />
    <coze-service-bot />
    <fast-gpt-bot />
  </div>
</template>

<script>
import FastGptBot from "@/components/FastGptBot.vue";
import CozeServiceBot from "@/components/CozeServiceBot.vue";

const PORTAL_PATH_RE = /^\/(index|face\/)/;

export default {
  name: "App",
  components: { FastGptBot, CozeServiceBot },
  computed: {
    isPortalSite() {
      const p = this.$route.path || "";
      return PORTAL_PATH_RE.test(p);
    },
  },
  watch: {
    isPortalSite: {
      immediate: true,
      handler(on) {
        if (typeof document === "undefined") return;
        document.documentElement.classList.toggle("portal-site", !!on);
      },
    },
  },
  beforeDestroy() {
    if (typeof document !== "undefined") {
      document.documentElement.classList.remove("portal-site");
    }
  },
};
</script>

<style lang="scss">
@import "@/styles/portal-scrollbars.scss";

#app-root {
  min-height: 100vh;
}
</style>
